<template>
  <div>
    <button v-if="locked" class="button lockButton" @click="setLocked(false)">
      <span class="tooltip">Unlock Soundboard</span>
      <i class="material-icons">lock</i>
    </button>
    <button v-else class="button lockButton" @click="setLocked(true)">
      <span class="tooltip">Lock Soundboard</span>
      <i class="material-icons">lock_open</i>
    </button>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState([
      'locked'
    ])
  },
  methods: {
    ...mapMutations([
      'setLocked'
    ])
  }
}
</script>

<style lang="stylus" scoped>
</style>